const VirusEvent = {
  OPEN_VIRUS_FOUND_MODAL: 'openVirusFoundModal',
};

export default VirusEvent;
